import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CustomDropDownComponent } from '../custom-drop-down/custom-drop-down.component';

@Component({
  selector: 'irembogov-custom-dropdown-paginated',
  templateUrl: './custom-dropdown-paginated.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomDropdownPaginatedComponent extends CustomDropDownComponent {
  getMoreDataMethod(event: boolean) {
    if (!event) return;
    const { dataset } = this.field.props;
    const httpMethod = dataset['httpMethod'];
    const url = this.field.props['useBaseUrl']
      ? this.updateUrlWithApiGatewayBaseUrl(dataset['url'])
      : dataset['url'];
    const params = dataset['params'];
    const headers = dataset['headers'];
    const dataField = dataset['dataField'];
    const totalPagesKey = dataset['totalPagesKey'];
    const currentPageKey = dataset['currentPageKey'];

    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      params.page = this.currentPage;
    }

    if (httpMethod === 'POST') {
      return this.getDataByPostMethod(
        url,
        dataField,
        params,
        headers,
        totalPagesKey,
        currentPageKey
      );
    } else {
      return this.getDataByGetMethod(
        url,
        dataField,
        params,
        headers,
        totalPagesKey,
        currentPageKey
      );
    }
  }

  searchData(value: any) {
    const { dataset } = this.field.props;
    if (!dataset['searching']) return;
    const { bindLabel } = this.field.props;
    const httpMethod = dataset['httpMethod'];
    const url = this.field.props['useBaseUrl']
      ? this.updateUrlWithApiGatewayBaseUrl(dataset['url'])
      : dataset['url'];
    const params = dataset['params'];
    const headers = dataset['headers'];
    const dataField = dataset['dataField'];
    const totalPagesKey = dataset['totalPagesKey'];
    const currentPageKey = dataset['currentPageKey'];

    this.items = [];
    params.page = 0;

    if (dataset['searchField']) {
      params[dataset['searchField']] = value;
    } else {
      params[bindLabel] = value;
    }

    if (httpMethod === 'POST') {
      return this.getDataByPostMethod(
        url,
        dataField,
        params,
        headers,
        totalPagesKey,
        currentPageKey
      );
    } else {
      return this.getDataByGetMethod(
        url,
        dataField,
        params,
        headers,
        totalPagesKey,
        currentPageKey
      );
    }
  }
}
